import { render, staticRenderFns } from "./HealthDetails.vue?vue&type=template&id=17b3ab76"
import script from "./HealthDetails.vue?vue&type=script&lang=js"
export * from "./HealthDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports